// removed by extract-text-webpack-plugin
module.exports = {"cellWidth":"200px","cellHeight":"25px","headerHeight":"60px","employeesHeight":"60px","hoursWidth":"45px","hoursTop":"120px","hoursTopMobile":"60px"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/components/timetable/_variables.scss
// module id = N9vy
// module chunks = 1